import React, {Component} from "react";
import {createRoot} from 'react-dom/client';
import Signin from "../components/Signin/Signin";
import "../../sass/_document.scss";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";


class SignIn extends Component {
    componentDidMount() {
        const dashboard = ConfigurationHelper.getDashboardSection();
        if(dashboard && dashboard.ambassador && dashboard.ambassador.tracking_pixel_apply && dashboard.ambassador.tracking_pixel_apply.length > 0){
            this.writeInNewIframe(dashboard.ambassador.tracking_pixel_apply);
        }
    }
    writeInNewIframe = (unsafeMarkup) => {
        const iframe = document.createElement('iframe');
        iframe.frameBorder = 0;
        iframe.style = "border: none; width: 0; height: 0;";
        iframe.scrolling = "no";
        document.body.append(iframe);
        iframe.contentWindow.document.write(unsafeMarkup);
        return iframe;
    }
    render() {
        return <div className={"document-body "+theme.hub_wrapper_css_class}>
            {ConfigurationHelper.enableHeaderFooter() && <Header/>}
            <Signin />
            {ConfigurationHelper.enableHeaderFooter() && <Footer/>}
        </div>;
    }
}

const root = createRoot(document.getElementById("app-container"))
root.render(<SignIn/>);